import { Component, inject, input } from '@angular/core';
import { ImagesService } from 'app/services/utilities/images.service';
import { PaymentMethodValidatorService } from 'app/services/utilities/payment-method-validator.service';

@Component({
    selector: 'app-display-card-type',
    templateUrl: './display-card-type.component.html',
    styleUrls: ['./display-card-type.component.scss'],
    standalone: false
})
export class DisplayCardTypeComponent {
    imgService = inject(ImagesService);
    protected paymentMethodValidator = inject(PaymentMethodValidatorService);

    readonly cardNumber = input<number>(undefined);
    readonly paymentProductId = input<number>(undefined);
    readonly highlight = input<boolean>(true);

    validateBrandName(brand: string): boolean {
        const paymentProductId = this.paymentProductId();
        if (paymentProductId) {
            let bool: boolean | any = this.paymentMethodValidator.detectCardTypeByPaymentProductId(paymentProductId, brand);
            return bool;
        } else {
            let bool: boolean | any = this.paymentMethodValidator.detectCardType(this.cardNumber(), brand);
            return bool;
        }
    }
}
